<div class="banner" [ngStyle]="{'color': colour, 'background-color': top, 'background-image': 'linear-gradient(to bottom, '+top+', '+bottom+')' }">
		<div class="content">
			<div class="text">
				<h2>{{heading}}</h2>
				<p [innerHtml]="html"></p>
			</div>
			<picture *ngIf="picture && picture.length > 0" [ngStyle]="{'object-position': align}">
				<source *ngFor="let src of picture" [srcset]="'/assets/' + src[0]" [type]="src[1]">
				<img loading="lazy" [src]="'/assets/'+picture[picture.length - 1][0]" [ngStyle]="{'object-position': align}">
				<!-- <img loading="lazy" [src]="'/assets/'+picture" [ngStyle]="{'object-position': align}"> -->
			</picture>
			<!-- <div class="picture" [ngStyle]="{'background-image': 'url(/assets/'+picture+')', 'background-position-y': align}"></div> -->
		</div>
</div>
